import { Injectable, EventEmitter } from '@angular/core';
import { ShopListInterface } from '../interfaces/shop-list-interface';

@Injectable({
  providedIn: 'root'
})
export class MinDelayCountdownService {
  private startingInterval = null;
  public paceMaker = new EventEmitter<null>();

  /**
   * Starts interval if interval isn't working
   * Sends signal every minute
   */
  startInterval() {
    if (this.startingInterval === null) {
      this.paceMaker.emit();
      this.startingInterval = setInterval(() => {
        this.paceMaker.emit();
      }, 60000);
    }
  }

  /**
   * Stops interval if interval is working
   */
  stopInterval() {
    if (this.startingInterval !== null) {
      clearInterval(this.startingInterval);
    }
  }

  /**
   * Checks if hours until bookingstop are <= 72 hours, for a specific shop
   * true: shop is relevant for countdown
   * false: shop has no countdown
   * @param shop checks hours of specific shop
   * @param startDate delivers the startdate from the bookingParameters for the calculation
   */
  isShopRelevantForCountdown(shop, startDate): boolean {
    if (this.getCountdownUntilBookingStop(shop, startDate) <= 4320) {
      // within 72 hour window?
      return true;
    }
    return false;
  }

  /**
   * calculate minutes until booking stop. Will respect timezone of user in perspective to GMT+1 of shop
   */
  getCountdownUntilBookingStop(shop: ShopListInterface, startDate: Date): number {
    const now = this.getNow(); // time with timezone of user
    const differenceOfTimeZoneToGmtPlusOne = now.getTimezoneOffset() - 60;
    const minutesUntilBookingDate =
      Math.floor((startDate.getTime() - now.getTime()) / 60000) - differenceOfTimeZoneToGmtPlusOne;
    const minutes = minutesUntilBookingDate - shop.min_delay * 60;

    return minutes;
  }

  getNow(): Date {
    return new Date();
  }
}
